// DescriptionPopup.js
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

export default function DescriptionPopup({
  open,
  title,
  description,
  onClose,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle style={{ fontSize: "18px" }}>
        {title || "Description"}
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: "14px" }}>{description}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
